import React, { PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

interface Props {
  className?: string;
}
const Tile = ({
  children,
  className = '',
  ref,
}: PropsWithChildren<Props> & { ref?: React.Ref<HTMLDivElement> }) => {
  return (
    <div
      className={cn(
        'relative rounded-[calc(var(--border-radius-base)*2)] border border-border bg-background shadow-[var(--tile-box-shadow-default)] hover:border-border hover:transition-[border] hover:duration-200',
        className
      )}
      ref={ref}
    >
      {children}
    </div>
  );
};

export default Tile;
